var map = {
	"./BNXT_Awards-winner-achievement-min.png": 9384,
	"./BNXT_Awards-winner-coach-min.png": 5231,
	"./BNXT_Awards-winner-defensive-min.png": 5443,
	"./BNXT_Awards-winner-dreamteam-min.png": 4338,
	"./BNXT_Awards-winner-mvp-min.png": 5486,
	"./BNXT_Awards-winner-player-min.png": 6119,
	"./BNXT_Awards-winner-referee-min.png": 5427,
	"./BNXT_Awards-winner-rising-min.png": 7482,
	"./BNXT_Awards-winner-sixthman-min.png": 7951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4598;